const mEditionMenu = {
  mEditionMenu: {
    account: {
      notifications: {
        subject: 'notificaciones',
        text: 'Notificaciones',

        children: {
          configuration: {
            goBackText: 'volver a listado',
            subedition: 'configuracion',
            text: 'Configuración'
          }
        }
      },

      profile: {
        subject: 'perfil',
        text: 'Datos de Perfil'
      },

      security: {
        subject: 'seguridad',
        text: 'Seguridad'
      }
    },

    asset: {
      content: {
        subject: 'contenido',
        text: 'Contenido',

        children: {
          node: {
            subedition: 'nodo',
            text: 'Nodo'
          }
        }
      }
    },

    billing: {
      myShopping: {
        subject: 'mis-compras',
        text: 'Mis Compras',

        children: {
          dataInvoice: {
            goBackText: 'volver atrás',
            subedition: 'datos-de-facturacion',
            text: 'Datos de Facturación'
          },

          invoice: {
            goBackText: 'volver atrás',
            subedition: 'comprobante',
            text: 'Comprobante'
          },

          invoicesHistory: {
            goBackText: 'volver atrás',
            subedition: 'historial-de-comprobantes',
            text: 'Historial de Comprobantes'
          },

          record: {
            goBackText: 'volver a listado',
            subedition: 'registro',
            text: 'Detalle de Compra'
          }
        }
      }
    },

    dropdownSearch: {
      title: 'Resultados'
    },

    inputSearch: {
      messageError: 'sin resultados',
      placeholder: 'Buscar contenido'
    },

    progress: 'de contenido visto'
  }
}

export default mEditionMenu
